@import '../../../../global/global.pcss';
@import '../../../common/item-list/styles/placeholders.pcss';
@import '../../../common/item-list/styles/list-display.pcss';
atomic-result:not(.hydrated) {
  visibility: hidden;
}
